import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/fillList_action";
import {
  role_detail_action,
  role_insertUpdate_action,
} from "../../../actions/security_action/roles_action";
import {
  moduleActionId,
  reportActionId,
  sessionExpireMessage,
  specialPermissionActionId,
  tokenInavlidMessage,
} from "../../../utils/constants";
import moment from "moment";
import Header from "../../../common_components/Header";

class RoleAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      userId: "",
      roleID: "",
      Name: "",
      Description: "",
      Status: false,
      roleList: [],
      showModal: false,
      moduleAccessList: [],
      reportAccessList: [],
      specialPermissionFillList: [],
      isSystemExpanded: false,
      CreatedBy: "",
      CreatedDate: "",
      ModifiedBy: "",
      ModifiedDate: "",
      DeletedBy: "",
      DeletedDate: "",
    };
    this.navigateBackRole = this.navigateBackRole.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.RoleDetails = this.RoleDetails.bind(this);
    this.clearFields = this.clearFields.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);

    if (this.props.location.state != null) {
      this.RoleDetails();
      this.setState({ roleID: this.props.location.state.roleID });
    } else {
      this.getFillList(
        moduleActionId,
        sessionStorage.getItem("userId"),
        "",
        ""
      );
      this.getFillList(
        reportActionId,
        sessionStorage.getItem("userId"),
        "",
        ""
      );
    }
    this.getFillList(
      specialPermissionActionId,
      sessionStorage.getItem("userId"),
      "",
      ""
    );
  }
  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId === "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error !== 1) {
          if (value === moduleActionId) {
            data.data.map((obj) => {
              obj.FullAccess = false;
              obj.ReadAccess = false;
              obj.WriteAccess = false;
              obj.UpdateAccess = false;
              obj.DeleteAccess = false;
            });
            this.setState({ moduleAccessList: data.data, isLoading: false });
          }
          if (value === reportActionId) {
            data.data.map((obj) => {
              obj.FullAccess = false;
              obj.DownloadAccess = false;
              obj.ViewAccess = false;
            });
            this.setState({ reportAccessList: data.data, isLoading: false });
            console.log(data.data, "report");
          }
          if (value === specialPermissionActionId) {
            this.setState({
              specialPermissionFillList: data.data,
              isLoading: false,
            });
            console.log(data.data, "special Permission");
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  navigateBackRole() {
    this.props.navigate("/role");
  }
  clearFields() {
    this.setState({
      roleID: "",
      Name: "",
      Description: "",
      StatusID: 0,
    });
  }
  RoleDetails() {
    const { userId, roleID, moduleAccessList, reportAccessList } = this.state;

    if (this.props.location.state.roleID) {
      this.props
        .role_detail_action(this.props.location.state.roleID)
        .then((data) => {
          if (data.error !== 1) {
            const { roleDetails, moduleAccess, reportAccess } = data;

            // Update Name and Description
            this.setState({
              Name: roleDetails.RoleName,
              Description: roleDetails.Description,
              Status: roleDetails.Status,
              moduleAccessList: data["moduleAccess"],
              reportAccessList: data["reportAccess"],
              CreatedBy: data["sysInfo"]["CreatedBy"],
              CreatedDate: data["sysInfo"]["CreatedDate"],
              ModifiedBy: data["sysInfo"]["ModifiedBy"],
              ModifiedDate: data["sysInfo"]["ModifiedDate"],
              DeletedBy: data["sysInfo"]["DeletedBy"],
              DeletedDate: data["sysInfo"]["DeletedDate"],
            },()=>{console.log(reportAccessList,"reportAccessListDetails")});
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toast.error(data.data, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  handleModuleCheckboxChange(e, index, accessType) {
    const { moduleAccessList } = this.state;
    const event = e.target.checked;
    if (accessType === "fullAccess") {
      moduleAccessList.map((obj, i) => {
        if (i === index) {
          if (event) {
            obj.FullAccess = true;
            obj.ReadAccess = true;
            obj.WriteAccess = true;
            obj.UpdateAccess = true;
            obj.DeleteAccess = true;
          } else {
            obj.FullAccess = false;
            obj.ReadAccess = false;
            obj.WriteAccess = false;
            obj.UpdateAccess = false;
            obj.DeleteAccess = false;
          }
        }
      });
      this.setState({ moduleAccessList: moduleAccessList });
    } else if (accessType === "readAccess") {
      moduleAccessList.map((obj, i) => {
        if (i === index) {
          if (event) {
            obj.ReadAccess = true;
          } else {
            obj.ReadAccess = false;
          }
        }
      });
      this.setState({ moduleAccessList: moduleAccessList });
    } else if (accessType === "writeAccess") {
      moduleAccessList.map((obj, i) => {
        if (i === index) {
          if (event) {
            obj.WriteAccess = true;
          } else {
            obj.WriteAccess = false;
          }
        }
      });
      this.setState({ moduleAccessList: moduleAccessList });
    } else if (accessType === "updateAccess") {
      moduleAccessList.map((obj, i) => {
        if (i === index) {
          if (event) {
            obj.UpdateAccess = true;
          } else {
            obj.UpdateAccess = false;
          }
        }
      });
      this.setState({ moduleAccessList: moduleAccessList });
    } else {
      moduleAccessList.map((obj, i) => {
        if (i === index) {
          if (event) {
            obj.DeleteAccess = true;
          } else {
            obj.DeleteAccess = false;
          }
        }
      });
      this.setState({ moduleAccessList: moduleAccessList });
    }
  }

  handleReportCheckboxChange(e, index, accessType) {
    const { reportAccessList } = this.state;
    const event = e.target.checked;
    if (accessType === "fullAccess") {
      reportAccessList.map((obj, i) => {
        if (i === index) {
          if (event) {
            obj.FullAccess = true;
            obj.DownloadAccess = true;
            obj.ViewAccess = true;
          } else {
            obj.FullAccess = false;
            obj.DownloadAccess = false;
            obj.ViewAccess = false;
          }
        }
      });
      this.setState({ reportAccessList: reportAccessList });
    } else if (accessType === "viewAccess") {
      reportAccessList.map((obj, i) => {
        if (i === index) {
          if (event) {
            obj.ViewAccess = true;
          } else {
            obj.ViewAccess = false;
          }
        }
      });
      this.setState({ reportAccessList: reportAccessList });
    } else {
      reportAccessList.map((obj, i) => {
        if (i === index) {
          if (event) {
            obj.DownloadAccess = true;
          } else {
            obj.DownloadAccess = false;
          }
        }
      });
      this.setState({ reportAccessList: reportAccessList });
    }
  }

  handleSubmit() {
    const {
      userId,
      roleID,
      Name,
      Description,
      moduleAccessList,
      reportAccessList,Status
    } = this.state;
    console.log(moduleAccessList);

    if (Name == "") {
      toast.error("Kindly Enter Name", {
        position: "top-center",
        theme: "colored",
        autoClose: 2000,
        hideProgressBar: true,
      });
    } else if (Description == "") {
      toast.error("Kindly Enter Description", {
        position: "top-center",
        theme: "colored",
        autoClose: 2000,
        hideProgressBar: true,
      });
    } else if (
      !moduleAccessList.some(
        (module) =>
          module.FullAccess ||
          module.WriteAccess ||
          module.ReadAccess ||
          module.UpdateAccess ||
          module.DeleteAccess
      )
    ) {
      toast.error("Please select at least one access option in Module Access", {
        position: "top-center",
        theme: "colored",
        autoClose: 2000,
        hideProgressBar: true,
      });
    } else {
      this.setState({ isLoading: true });

      const modulArray = [];
      const reportArray = [];

      if (roleID != "") {
        moduleAccessList.map((data) => {
          modulArray.push({
            ModuleID: data.ModuleID,
            FullAccess: data.FullAccess,
            WriteAccess: data.WriteAccess,
            ReadAccess: data.ReadAccess,
            UpdateAccess: data.UpdateAccess,
            DeleteAccess: data.DeleteAccess,
            Is_SpecialAccess: false,
          });
        });
        reportAccessList.map((data) => {
          reportArray.push({
            ReportID: data.ReportID,
            FullAccess: data.FullAccess,
            ViewAccess: data.ViewAccess,
            DownloadAccess: data.DownloadAccess,
          });
        });
      } else {
        moduleAccessList.map((data) => {
          modulArray.push({
            ModuleID: data.MODULEID,
            FullAccess: data.FullAccess,
            WriteAccess: data.WriteAccess,
            ReadAccess: data.ReadAccess,
            UpdateAccess: data.UpdateAccess,
            DeleteAccess: data.DeleteAccess,
            Is_SpecialAccess: false,
          });
        });
        reportAccessList.map((data) => {
          reportArray.push({
            ReportID: data.ReportID,
            FullAccess: data.FullAccess,
            ViewAccess: data.ViewAccess,
            DownloadAccess: data.DownloadAccess,
          });
        });
      }

      this.props
        .role_insertUpdate_action(
          roleID,
          Name,
          Description,
          modulArray,
          reportArray,Status
        )
        .then((data) => {
          console.log(data);

          if (data && data.error === 0) {
            this.setState({ isLoading: false }, () => {
              toast.success(roleID
                ? "Data Updated Successfully"
                : "Data Inserted Successfully", {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
              });
  })
            setTimeout(() => {
                this.props.navigate("/role");
            }, 1500);
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              const errorMessage =
                data && data.msg ? data.msg : "An unknown error occurred.";

              toast.error(errorMessage, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ isLoading: false });
          toast.error("An unexpected error occurred.", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        });
    }
  }

  render() {
    const {
      isLoading,
      isAccordionExpanded,
      moduleAccessList,
      reportAccessList,
      Name,
      Description,
      specialPermissionFillList,
      Status,
      roleID,
      isSystemExpanded,
      CreatedBy,
      CreatedDate,
      ModifiedBy,
      ModifiedDate,
      DeletedBy,
      DeletedDate,
    } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[20]} />
            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">
                    {roleID ? "Edit" : "Add"} Role
                  </h4>
                  <div className="Service_display pt-2">
                    <h6 className="Services_Active_or_Not">{roleID?Status == 1 ? "Active" : "Inactive":"Active"}</h6>
                    <div className="checkbox checbox-switch">
                      <label className="switch">
                      {roleID?(
                             <>
                         
                             <input
                               type="checkbox"
                               checked={Status}
                               onChange={() => {
                                 this.setState((prevState) => ({
                                   Status: !prevState.Status,
                                 }));
                               }}
                             />
                             <span class="slider round"></span>
                             </>

                        ):(
                          <>
                          <input
                                                    type="checkbox"
                                                    checked={1}
                                                   
                                                  />
                                                  <span class="slider round"></span></>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="card Service_fields">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-2">
                        <div className="form-group">
                          <label htmlFor="inputZip">
                            Role Name <span className="required_field">*</span>{" "}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fname"
                            name="name"
                            value={Name}
                            onChange={(e) => {
                              this.setState({ Name: e.target.value });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-10">
                        <div className="form-group">
                          <label htmlFor="inputZip">
                            Role Description{" "}
                            <span className="required_field">*</span>{" "}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fname"
                            name="name"
                            value={Description}
                            onChange={(e) => {
                              this.setState({ Description: e.target.value });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-7">
                        <h6>Module Access</h6>
                        <div className="custom_table">
                          <div className="hack1">
                            <div className="hack2">
                              <table
                                className="table table-bordered table-striped"
                                id="dashboard-table"
                              >
                                <thead>
                                  <tr className="text-center">
                                    <th>Module Name</th>
                                    <th>Full Access</th>
                                    <th>Read</th>
                                    <th>Write</th>
                                    <th>Update</th>
                                    <th>Delete</th>
                                    <th>Special Permissions</th>
                                  </tr>
                                </thead>
                                <tbody id="myTable">
                                {moduleAccessList && moduleAccessList.length > 0 ? 
    moduleAccessList.map((data, i) => (
                                          <tr key={i}>
                                            <td className="text-center">
                                              {data.ModuleName}
                                            </td>
                                            <td>
                                              <div className="bg">
                                                <div className="chiller_cb align-self-center align-self-center">
                                                  <input
                                                    id={`Modulecheck2${i}`}
                                                    type="checkbox"
                                                    checked={data.FullAccess}
                                                    onChange={(e) =>
                                                      this.handleModuleCheckboxChange(
                                                        e,
                                                        i,
                                                        "fullAccess"
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`Modulecheck2${i}`}
                                                  >
                                                    &nbsp;
                                                  </label>
                                                  <span />
                                                </div>
                                              </div>
                                            </td>
                                            <td>
                                              <div className="bg">
                                                <div className="chiller_cb align-self-center">
                                                  <input
                                                    id={`Modulecheck3${i}`}
                                                    type="checkbox"
                                                    checked={data.ReadAccess}
                                                    onChange={(e) =>
                                                      this.handleModuleCheckboxChange(
                                                        e,
                                                        i,
                                                        "readAccess"
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`Modulecheck3${i}`}
                                                  >
                                                    &nbsp;
                                                  </label>
                                                  <span />
                                                </div>
                                              </div>
                                            </td>
                                            <td>
                                              <div className="bg">
                                                <div className="chiller_cb align-self-center">
                                                  <input
                                                    id={`Modulecheck4${i}`}
                                                    type="checkbox"
                                                    checked={data.WriteAccess}
                                                    onChange={(e) =>
                                                      this.handleModuleCheckboxChange(
                                                        e,
                                                        i,
                                                        "writeAccess"
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`Modulecheck4${i}`}
                                                  >
                                                    &nbsp;
                                                  </label>
                                                  <span />
                                                </div>
                                              </div>
                                            </td>
                                            <td>
                                              <div className="bg">
                                                <div className="chiller_cb align-self-center">
                                                  <input
                                                    id={`Modulecheck5${i}`}
                                                    type="checkbox"
                                                    checked={data.UpdateAccess}
                                                    onChange={(e) =>
                                                      this.handleModuleCheckboxChange(
                                                        e,
                                                        i,
                                                        "updateAccess"
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`Modulecheck5${i}`}
                                                  >
                                                    &nbsp;
                                                  </label>
                                                  <span />
                                                </div>
                                              </div>
                                            </td>
                                            <td>
                                              <div className="bg">
                                                <div className="chiller_cb align-self-center">
                                                  <input
                                                    id={`Modulecheck6${i}`}
                                                    type="checkbox"
                                                    checked={data.DeleteAccess}
                                                    onChange={(e) =>
                                                      this.handleModuleCheckboxChange(
                                                        e,
                                                        i,
                                                        "deleteAccess"
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`Modulecheck6${i}`}
                                                  >
                                                    &nbsp;
                                                  </label>
                                                  <span />
                                                </div>
                                              </div>
                                            </td>
                                            <td className="text-right">
                                              <div className="custom_dropdow">
                                                <div
                                                  className="dropdown dropright"
                                                  title=""
                                                >
                                                  <a className="dropbtn">
                                                    <i className="fa fa-star" />
                                                  </a>
                                                  <div className="dropdown-content custom_dropdown_with_checkbox">
                                                    <div className="bg">
                                                      {specialPermissionFillList &&
                                                      specialPermissionFillList.length >
                                                        0
                                                        ? specialPermissionFillList.map(
                                                            (data, j) => (
                                                              <div
                                                                className="chiller_cb align-self-center"
                                                                key={j}
                                                              >
                                                                <input
                                                                  id={`SpecialPermissionCheck${i}-${j}`}
                                                                  type="checkbox"
                                                                  // checked={
                                                                  //   this.state.moduleAccessList[i]?.Is_SpecialAccess[j] || false
                                                                  // }
                                                                  // onChange={(e) =>
                                                                  //   this.handleModuleCheckboxChange(
                                                                  //     i,
                                                                  //     `specialAccess`,
                                                                  //     e.target
                                                                  //       .checked,
                                                                  //     j
                                                                  //   )
                                                                  // }
                                                                />

                                                                <label
                                                                  // htmlFor={`SpecialPermissionCheck${i}-${j}`}
                                                                  className="specialPermissionCheckboxes"
                                                                >
                                                                  {
                                                                    data.SpecialPermission
                                                                  }
                                                                </label>
                                                                <span />
                                                              </div>
                                                            )
                                                          )
                                                        : null}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        ))
                                    : null}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <h6>Report Access</h6>
                        <div className="custom_table">
                          <div className="hack1">
                            <div className="hack2">
                              <table
                                className="table table-bordered table-striped"
                                id="dashboard-table"
                              >
                                <thead>
                                  <tr className="text-center">
                                    <th>Report Name</th>
                                    <th>Full Access</th>
                                    <th>View</th>
                                    <th className="text-right">Download</th>
                                  </tr>
                                </thead>
                                <tbody id="myTable">
                                {reportAccessList && reportAccessList.length > 0 ? 
    reportAccessList.map((data, i) => (
                                          <tr key={i}>
                                            <td className="text-center">
                                              {data.Name || data.reportname}
                                            </td>
                                            <td>
                                              <div className="bg">
                                                <div className="chiller_cb align-self-center">
                                                  <input
                                                    id={`reportCheck2${i}`}
                                                    type="checkbox"
                                                    checked={data.FullAccess}
                                                    onChange={(e) =>
                                                      this.handleReportCheckboxChange(
                                                        e,
                                                        i,
                                                        "fullAccess"
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`reportCheck2${i}`}
                                                  >
                                                    &nbsp;
                                                  </label>
                                                  <span />
                                                </div>
                                              </div>
                                            </td>
                                            <td>
                                              <div className="bg">
                                                <div className="chiller_cb align-self-center">
                                                  <input
                                                    id={`reportCheck3${i}`}
                                                    type="checkbox"
                                                    checked={data.ViewAccess}
                                                    onChange={(e) =>
                                                      this.handleReportCheckboxChange(
                                                        e,
                                                        i,
                                                        "viewAccess"
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`reportCheck3${i}`}
                                                  >
                                                    &nbsp;
                                                  </label>
                                                  <span />
                                                </div>
                                              </div>
                                            </td>
                                            <td className="text-right">
                                              <div className="bg">
                                                <div className="chiller_cb align-self-center">
                                                  <input
                                                    id={`reportCheck4${i}`}
                                                    type="checkbox"
                                                    checked={
                                                      data.DownloadAccess
                                                    }
                                                    onChange={(e) =>
                                                      this.handleReportCheckboxChange(
                                                        e,
                                                        i,
                                                        "downloadAccess"
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`reportCheck4${i}`}
                                                  >
                                                    &nbsp;
                                                  </label>
                                                  <span />
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        ))
                                    : null}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div class="p-2 mt-3 mb-3">
                        <a
                          className="btn save_btn"
                          onClick={() => this.handleSubmit()}
                        >
                          {roleID ? "Update" : "Save"}
                        </a>
                      </div>
                      <div class="p-2 mt-3 mb-3">
                        <a
                          onClick={this.navigateBackRole}
                          className="btn back_btn"
                        >
                          Back
                        </a>
                      </div>
                    </div>
                    {roleID ? (
                      <div
                        className="system_info"
                        aria-expanded={isSystemExpanded}
                        onClick={() =>
                          this.setState({
                            isSystemExpanded: !isSystemExpanded,
                          })
                        }
                      >
                        <div className="row row_margin collpase_arrow_cursor">
                          <div className="col-md-6 col-sm-6 col-7">
                            <span
                              data-toggle="collapse"
                              data-target="#Sys_info"
                              className=""
                            >
                              <i
                                className={
                                  isSystemExpanded
                                    ? "fa fa-chevron-down CRM_rotate_data"
                                    : "fa fa-chevron-right CRM_rotate_data"
                                }
                                style={{ fontSize: 12, color: "#898989" }}
                              />
                              <span
                                className="heading_text"
                                style={{ paddingLeft: 5 }}
                              >
                                System Info
                              </span>
                            </span>
                          </div>
                          <div className="col-md-6 col-sm-6 col-5 text-right">
                            {/* <span style="color:#10c5e3;position: relative;top: -3px;right: 3px; display:none;"></span>
            <i class="fa fa-plus-circle" data-toggle="modal" data-target="#Add_new_trade_modal" style="font-size: 20px;cursor:pointer;line-height:20px;color: #898989;"></i> */}
                          </div>
                        </div>
                        <hr
                          style={{
                            marginTop: 0,
                            marginBottom: 15,
                            border: "1px solid #c0c0c0",
                          }}
                        />
                        <div
                          id="collapseOne"
                          className={`panel-collapse collapse ${
                            isSystemExpanded ? "show" : ""
                          }`}
                          aria-labelledby="headingOne"
                        >
                          <div className="form-group">
                            <div className="row">
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label
                                    className="sys_info_label"
                                    htmlFor="email"
                                  >
                                    Created By
                                  </label>
                                  <p className="Sys_info_style">
                                    {CreatedDate != null
                                      ? CreatedBy
                                      : "Not Available"}
                                  </p>
                                </div>
                                <div className="form-group">
                                  <label
                                    className="sys_info_label"
                                    htmlFor="email"
                                  >
                                    Created Date
                                  </label>
                                  <p className="Sys_info_style">
                                    {CreatedDate != ""
                                      ? moment(CreatedDate).format("DD-MM-YYYY")
                                      : ""}
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label
                                    className="sys_info_label"
                                    htmlFor="email"
                                  >
                                    Modified By
                                  </label>
                                  <p className="Sys_info_style">
                                    {ModifiedDate != null
                                      ? ModifiedBy
                                      : "Not Available"}
                                  </p>
                                </div>
                                <div className="form-group">
                                  <label
                                    className="sys_info_label"
                                    htmlFor="email"
                                  >
                                    Modified Date
                                  </label>
                                  <p className="Sys_info_style">
                                    {ModifiedDate != null
                                      ? moment(ModifiedDate).format(
                                          "DD-MM-YYYY"
                                        )
                                      : "Not Available"}
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label
                                    className="sys_info_label"
                                    htmlFor="email"
                                  >
                                    Deleted By
                                  </label>
                                  <p className="Sys_info_style">
                                    {DeletedDate != null
                                      ? DeletedBy
                                      : "Not Available"}
                                  </p>
                                </div>
                                <div className="form-group">
                                  <label
                                    className="sys_info_label"
                                    htmlFor="email"
                                  >
                                    Deleted Date
                                  </label>
                                  <p className="Sys_info_style">
                                    {DeletedDate != null
                                      ? moment(DeletedDate).format("DD-MM-YYYY")
                                      : "Not Available"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </main>
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, { fill_action, role_insertUpdate_action, role_detail_action })(
    RoleAdd
  )
);
